"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RepaymentPlanTypeKey = exports.IBR_NEW_BORROWER_DATE = void 0;
exports.IBR_NEW_BORROWER_DATE = '2014-07-01';
var RepaymentPlanTypeKey;
(function (RepaymentPlanTypeKey) {
    RepaymentPlanTypeKey["STANDARD_REPAYMENT"] = "STANDARD REPAYMENT";
    RepaymentPlanTypeKey["REVISED_PAY_AS_YOU_EARN_PLAN"] = "REVISED PAY AS YOU EARN PLAN";
    RepaymentPlanTypeKey["POST_REVISED_PAY_AS_YOU_EARN_ALTERNATIVE_PLAN"] = "POST-REVISED PAY AS YOU EARN ALTERNATIVE PLAN";
    RepaymentPlanTypeKey["PAY_AS_YOU_EARN_REPAYMENT"] = "PAY AS YOU EARN REPAYMENT";
    RepaymentPlanTypeKey["INCOME_SENSITIVE_REPAYMENT"] = "INCOME-SENSITIVE REPAYMENT";
    RepaymentPlanTypeKey["INCOME_CONTINGENT_REPAYMENT"] = "INCOME-CONTINGENT REPAYMENT";
    RepaymentPlanTypeKey["INCOME_BASED_REPAYMENT"] = "INCOME-BASED REPAYMENT";
    RepaymentPlanTypeKey["GRADUATED_REPAYMENT"] = "GRADUATED REPAYMENT";
    RepaymentPlanTypeKey["EXTENDED_GRADUATED_REPAYMENT"] = "EXTENDED GRADUATED REPAYMENT";
    RepaymentPlanTypeKey["EXTENDED_REPAYMENT"] = "EXTENDED REPAYMENT";
    RepaymentPlanTypeKey["ALTERNATIVE_FIXED_TERM_REPAYMENT_PLAN"] = "ALTERNATIVE FIXED TERM REPAYMENT PLAN";
    RepaymentPlanTypeKey["SAVING_ON_A_VALUABLE_EDUCATION_PLAN"] = "SAVING ON A VALUABLE EDUCATION PLAN";
})(RepaymentPlanTypeKey || (exports.RepaymentPlanTypeKey = RepaymentPlanTypeKey = {}));
